import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ConfirmationService, } from 'primeng/api';
import { CoreService } from '../core/_services/core.services';
import { AlertasService } from '../core/_services/alerta.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ValidatorUtils } from '../core/_util/validator-util';

@Component({
  selector: 'app-ans',
  templateUrl: './ans.component.html',
  styleUrls: ['./ans.component.scss']
})
export class AnsComponent extends ValidatorUtils implements OnInit {

  @Input() fichaActual: any;

  cargandoTabla: boolean = false;

  //formulario
  formBuilder: FormBuilder;
  formulario: FormGroup;
  mostrarFormulario: Boolean = false;
  registroNuevo: Boolean = false;
  submitted: Boolean = false;
  listaCaracteristica: any;
  totalRecords = 0;
  listadoAns: any[];
  caracteristica: any;
  columnas: any[];
  rango_inicial: any[];
  rango_final: any[];

  constructor(
    public coreService: CoreService,
    public spinner: NgxSpinnerService,
    public msj: AlertasService,
    public confirmationService: ConfirmationService
  ) {
    super();
    this.formBuilder = new FormBuilder();
    this.formulario = this.formBuilder.group({
      rangoinicial: ['', Validators.required],
      rangofinal: ['', Validators.required],
      valor: ['', Validators.required],
      caracteristica: ['', Validators.required],
      observacion: ['', Validators.required],
    });

  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'dias_ans', header: 'Dias de Servicio' },
      { field: 'rango_inf', header: 'Rango Inicial Candidatos' },
      { field: 'rango_sup', header: 'Rango Final Candidatos' },
      { field: 'observacion', header: 'Observación' },
    ];

    this.totalRecords = 0;
    this.listar();
    this.getListaCaracteristica();

  }

  volver() {
    this.mostrarFormulario = false;
    this.submitted = false;
  }

  prepararNuevo() {
    this.formulario.reset();
    this.mostrarFormulario = true;
    this.registroNuevo = true;
  }

  getListaCaracteristica() {
    this.coreService.get('/obtenerCaracteristica').subscribe(
      (res: any) => {
        this.listaCaracteristica = res;
      },
      (err: any) => {
        console.log(err);
      }
    )

  }

  guardar() {
    var dat = this.formulario.valid;
    this.formulario.markAllAsTouched();
    if (dat) {
      this.confirmationService.confirm({
        message: '¿Desea guardar este registro?',
        accept: () => {
          this.submitted = true;
          this.guardarServicio();
        }
      });
    }
  }


  guardarServicio() {

    let data = {
      fichaActual: this.fichaActual,
      caracteristica: this.formulario.value.caracteristica.id,
      rango_inf: this.formulario.value.rangoinicial,
      rango_sup: this.formulario.value.rangofinal,
      dias_ans: this.formulario.value.valor,
      observacion: this.formulario.value.observacion,

    }
    this.coreService.post('/guardar-ans', data).subscribe(
      (res: any) => {
        this.msj.info(res);
        this.listar();
        this.mostrarFormulario = false;

      },
      (err: any) => {
        console.log(err);
      }
    )
  }

  listar() {
    let data = {
      id_ficha: this.fichaActual
    }
    this.mostrarFormulario = false;
    this.cargandoTabla = true;
    this.coreService.getWithParams('/obtenerAnsFicha', data).subscribe(
      (res: any[]) => {
        if(res){
          this.listadoAns = res;
          this.totalRecords = this.listadoAns.length;
        } else {
          this.listadoAns = null;
          this.totalRecords = 0;
        }
        this.cargandoTabla = false;
      },
      (err: any) => {
        this.cargandoTabla = false;
        console.log(err);
      }
    )
  }

  eliminar(idRegistro) {
    this.confirmationService.confirm({
      message: '¿Desea eliminar el registro con ID:' + idRegistro.id + '?',
      accept: () => {
        this.submitted = true;
        this.eliminarServicio(idRegistro.id);
        this.mostrarFormulario = false;
      }
    });
  }

  eliminarServicio(idRegistro) {
    this.coreService.delete('/eliminar-ans', idRegistro).subscribe(
      (res: any[]) => {
        this.msj.info('Registro Eliminado.');
        this.listar();
      },
      (err: any) => {
        if (err.error !== undefined && err.error !== null) {
          for (let index = 0; index < err.error.length; index++) {
            this.msj.error(err.error[index]);
          }
        }
      }
    );
  }

}
